const SvgDislikeContained = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 6.725L9.075 3.675C8.975 2.85 8.275 2.25 7.45 2.25H5.125C3.675 2.25 2.5 3.425 2.5 4.875V6.525C2.5 7.15 2.8 7.775 3.325 8.275C3.975 8.9 5.55 11.175 5.55 11.2C5.575 11.225 5.6 11.25 5.65 11.25H5.675C5.95 11.2 6.5 10.925 6.5 10.2C6.5 10.05 6.475 9.85 6.4 9.575C6.3 9.075 6.175 8.675 5.975 8.225C5.95 8.175 5.95 8.125 5.975 8.075C6 8.05 6.025 8.025 6.075 8.025H8.375C8.7 8.025 9 7.875 9.225 7.65C9.45 7.375 9.55 7.05 9.5 6.725Z"
        className="fill-current"
      />
    </svg>
  );
};

export default SvgDislikeContained;
